// Matched by name, as the backend does: record type ids are per branch and change on every seed.
export const RECORD_TYPE_UPLOAD_NAME = 'Upload';

// The API sends this one without the final period every notice of the screens ends with.
export const GENERATED_RECORD_NOT_FOUND_MESSAGE = 'Registro não encontrado.';
